import { Component } from '@angular/core';

@Component({
  selector: 'app-how-it-works-section',
  templateUrl: './how-it-works-section.component.html'
})
export class HowItWorksSectionComponent {

}
